import Swiper from 'swiper';

(function ($) {
  'use strict';

  $(document).ready(function () {
    var swiper = new Swiper('.client-logo.swiper', {
      loop: false,
      centerSlides: true,
      spaceBetween: 24,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        320: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        1400: {
          slidesPerView: 5,
          spaceBetween: 30,
        },
        1900: {
          slidesPerView: 6,
          spaceBetween: 40,
        },
      },
      navigation: {
        nextEl: '.logo-slider-button-next',
        prevEl: '.logo-slider-button-prev',
      },
      // on: {
      //   init: function (swiper) {
      //     updateNavVisibility(swiper);
      //   },
      //   resize: function (swiper) {
      //     updateNavVisibility(swiper);
      //   },
      //   slideChange: function (swiper) {
      //     updateNavVisibility(swiper);
      //   },
      // },
    });

    var swiperEnabledText = new Swiper('.client-logo.swiper.enabled-text', {
      loop: false,
      centerSlides: true,
      spaceBetween: 24,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1900: {
          slidesPerView: 5,
          spaceBetween: 55,
        },
      },
      navigation: {
        nextEl: '.logo-slider-button-next',
        prevEl: '.logo-slider-button-prev',
      },
      // on: {
      //   init: function (swiper) {
      //     updateNavVisibility(swiper);
      //   },
      //   resize: function (swiper) {
      //     updateNavVisibility(swiper);
      //   },
      //   slideChange: function (swiper) {
      //     updateNavVisibility(swiper);
      //   },
      // },
    });
  });

  // Show/hide swiper nav wrapper 
  function updateNavVisibility(swiper) {
    const totalSlides = document.querySelectorAll(
      '.client-logo.swiper .swiper-slide'
    ).length;
    const visibleSlides = swiper.params.slidesPerView;

    if (totalSlides <= visibleSlides) {
      $('.slider-nav-wrapper').addClass('d-none');
    } else {
      $('.slider-nav-wrapper').removeClass('d-none');
    }
  }
})(jQuery);
